import React, { useState, useEffect } from "react";

import AgGridReactEx from "@app/components/AgGridReactEx";

const MainContent = ({data, height}) => {
    const [tableData, setTableData] = useState(null);

    useEffect(() => {
        setTableData(listSearch(null));
        return () => {};
    }, [data]);

    const listSearch = (keyword) => {
        var list = data;
        var tableData = [];
        tableData = list;
        return tableData;
    };

    const defaultColDef = {
        editable: false,
        sortable: false,
        flex: 1,
        minWidth: 60,
        filter: false,
        resizable: true,
        cellClass: "text-center",
        headerClass: "bg-dark text-light",
    };

    const listColumn = [
        {
            headerName: "콘텐츠명",
            field: "contentName",
            minWidth: 170,
            pinned: 'left'
        },
        {
            headerName: "콘텐츠ID",
            field: "contentId",
            minWidth: 80,
        },
        {
            headerName: "메뉴",
            field: "menu",
            minWidth: 90,
            cellRenderer: (param) => {
                return param.value;
            },
        },
        {
            headerName: "연령",
            field: "age",
            minWidth: 70,
            cellRenderer: (param) => {
                return param.value == 345 ? "혼합" : `만${param.value}세`;
            },
        },
        {
            headerName: "영역",
            field: "area",
            minWidth: 90,
            cellRenderer: (param) => {
                return param.value;
            },
        },
        {
            headerComponentParams: {
                template:
                    '<div class="ag-cell-label-container" role="presentation"><span ref="eMenu" class="ag-header-icon ag-header-cell-menu-button"></span><div ref="eLabel" class="ag-header-cell-label text-center" role="presentation">다운로드<br/>수</div></div>',
            },
            field: "downloadCount",
            minWidth: 75,
            cellRenderer: (param) => {
                return param.value ? param.value.toLocaleString() : "-";
            },
        },
        {
            headerComponentParams: {
                template:
                    '<div class="ag-cell-label-container" role="presentation"><span ref="eMenu" class="ag-header-icon ag-header-cell-menu-button"></span><div ref="eLabel" class="ag-header-cell-label text-center" role="presentation">순<br/>실행 수</div></div>',
            },
            field: "playCount",
            minWidth: 75,
            cellRenderer: (param) => {
                return param.value ? param.value.toLocaleString() : "-";
            },
        },
        {
            headerComponentParams: {
                template:
                    '<div class="ag-cell-label-container" role="presentation"><span ref="eMenu" class="ag-header-icon ag-header-cell-menu-button"></span><div ref="eLabel" class="ag-header-cell-label text-center" role="presentation">누적<br/>실행 수</div></div>',
            },
            field: "playCountSum",
            minWidth: 75,
            cellRenderer: (param) => {
                return param.value ? param.value.toLocaleString() : "-";
            },
        },
    ];

    return <AgGridReactEx height="242" headerHeight={40} defaultColDef={defaultColDef} columnDefs={listColumn} rowData={tableData} pagination={false} />;
};

export default MainContent;
